export default __webpack_public_path__ + "static/media/team-call.e109dc9b.wav";